import React from 'react';
import { ControlPad } from '../../shared/components/controlPad';
import { Grid2 as Grid } from '@mui/material';
import { BoxRowStyled } from './style';
import '../../index.css';
import { TileGridGroup } from './tilegridgroup';
import { controlPadData } from '../../shared/shared.constants';
import { ContainerStyled } from '../../styles/globalStyles';

export const HomeScreen = () => {
  return (
    <BoxRowStyled sx={{ alignItems: 'center' }}>
      <ContainerStyled>
        <TileGridGroup />
        <Grid container spacing={2}>
          {controlPadData.map((item) => (
            <ControlPad
              key={item.altVal}
              imgSrc={item.imgSrc}
              altVal={item.altVal}
              toLink={item.toLink}
              showIcon={item.showIcon}
            />
          ))}
        </Grid>
      </ContainerStyled>
    </BoxRowStyled>
  );
};
